export const projects = [
  {
    name: "large",
    tools: [
      "HTML",
      "CSS",
      "Javascript",
      "MongoDB",
      "Express.js",
      "React.js",
      "Node.js",
      "Mongoose",
      "Redux",
      "Bcrypt",
      "JWT",
    ],
    preview: {
      mobile: "/assets/images/detail/mobile/image-large-preview-1.jpg",
      tablet: "/assets/images/detail/tablet/image-large-preview-1.jpg",
      desktop: "/assets/images/detail/desktop/image-large-preview-1.jpg",
    },
    description:
      "Large is an open publishing platform to share your thoughts and experiences on the world's most controversial matters today.",
    github: "https://github.com/vlsalina/large-social-media-app-client",
    demo: "https://large-social-media.netlify.app",
  },
  {
    name: "audiophile",
    tools: [
      "HTML",
      "CSS",
      "Javascript",
      "MongoDB",
      "Express.js",
      "React.js",
      "Node.js",
      "Mongoose",
      "Redux",
    ],
    preview: {
      mobile: "/assets/images/detail/mobile/image-audiophile-preview-1.png",
      tablet: "/assets/images/detail/tablet/image-audiophile-preview-1.png",
      desktop: "/assets/images/detail/desktop/image-audiophile-preview-1.png",
    },
    description: `Audiophile is a project challenge from Frontendmentor.io to help aspiring developers by building realistic projects.`,
    github: "https://github.com/vlsalina/audiophile-ecommerce-client",
    demo: "https://audiophile-ecommerce-app.netlify.app",
  },
  {
    name: "pet rescue",
    tools: ["HTML", "CSS", "Javascript", "React.js", "GSAP"],
    preview: {
      mobile: "/assets/images/detail/mobile/image-pet-rescue-preview-1.png",
      tablet: "/assets/images/detail/tablet/image-pet-rescue-preview-1.png",
      desktop: "/assets/images/detail/desktop/image-pet-rescue-preview-1.png",
    },
    description:
      "Pet Rescue is the front page for a nonprofit organization dedicated to helping pets find a forever home.",
    github: "https://github.com/vlsalina/pet-rescue-website",
    demo: "https://pet-rescue-site.netlify.app",
  },
];

export const socials = [
  {
    media: "github",
    icon: "/assets/images/icons/github.svg",
    url: "https://github.com/vlsalina/",
  },
  {
    media: "linkedin",
    icon: "/assets/images/icons/linkedin.svg",
    url: "https://www.linkedin.com/in/vincent-salinas-24123a232/",
  },
];

export const hero = {
  mobile: "/assets/images/homepage/mobile/image-homepage-hero.jpg",
  tablet: "/assets/images/homepage/tablet/image-homepage-hero.jpg",
  desktop: "/assets/images/homepage/desktop/image-homepage-hero.jpg",
};

export const menu = ["home", "projects", "contact me", "resume"];

export const about = {
  mobile: "/assets/images/detail/mobile/home-preview-2.jpg",
  tablet: "/assets/images/detail/tablet/home-preview-2.jpg",
  desktop: "/assets/images/detail/desktop/home-preview-2.jpg",
};

export const texts = {
  aboutme:
    "I'm a junior front-end developer looking for a new role at an exciting company. I focus on writing accessible HTML, using modern CSS practices and writing well-structured Javascript. When writing Javascript code, I mostly use React, but I can adapt to whatever technologies are required. When I'm not coding, I love relaxing and enjoying my time at home. I'd love for you to check out my work.",
  intro: "Hey, I'm Nikolai and I love building beautiful websites",
};
